import { Component, OnInit, ViewChild,HostListener} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from '../sidebar/sidebar';
import { ChatAreaComponent } from '../chat-area/chat-area';
import { RoleService } from '../../../../shared/services/role.service';
import { ChatHistoryMessage, ChatHistoryItem } from '../../interfaces/chat-history-response.interface';
import { Subscription } from 'rxjs';
import { OrganogramIdentityService } from '../../services/organogram-identity.service';

@Component({
  selector: 'app-chat-layout',
  standalone: true,
  imports: [CommonModule, SidebarComponent, ChatAreaComponent],
  templateUrl: './chat-layout.html'
})
export class ChatLayoutComponent implements OnInit {
  @ViewChild(ChatAreaComponent) chatAreaComponent!: ChatAreaComponent;
  @ViewChild(SidebarComponent) sidebarComponent!: SidebarComponent;

  isSidebarCollapsed = false;
  isMobileMenuOpen = false;
  showCollections = false;
  showFeedbackAdmin = false;
  showMailbox = false;
  showVisualizations = false;
  showInferences = false;
  showClusters = false;
  showMembers = false;
  canViewCollections = false;
  canViewFeedback = false;
  canViewMailbox = false;
  canViewVisualizations = false;
  canViewInferences = false;
  canViewMembers = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private roleService: RoleService,
    private organogramIdentity: OrganogramIdentityService
  ) {}

  ngOnInit(): void {
    this.canViewCollections = this.roleService.canViewCollections();
    this.canViewFeedback = this.roleService.canViewFeedback();
    this.canViewMailbox = this.roleService.canViewMailbox();
    this.canViewVisualizations = this.roleService.canViewVisualizations();
    this.canViewInferences = this.roleService.canViewInferences();
    this.canViewMembers = this.roleService.canViewMembers();
    this.organogramIdentity.refresh();
    if (window.innerWidth <= 768) {
    this.isSidebarCollapsed = false;
    }
  }

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  onCollectionsClicked(): void {
    if (this.canViewCollections) {
      this.showCollections = true;
      this.showFeedbackAdmin = false;
      this.showVisualizations = false;
      this.showMailbox = false;
      this.showInferences = false;
      this.showClusters = false;
      this.showMembers = false;
    }
  }

  onFeedbackClicked(): void {
    if (this.canViewFeedback) {
      this.showFeedbackAdmin = true;
      this.showCollections = false;
      this.showMailbox = false;
      this.showVisualizations = false;
      this.showInferences = false;
      this.showClusters = false;
      this.showMembers = false;
    }
  }

  onMailboxClicked(): void {
    if (this.canViewMailbox) {
      this.showMailbox = true;
      this.showCollections = false;
      this.showFeedbackAdmin = false;
      this.showVisualizations = false;
      this.showInferences = false;
      this.showClusters = false;
      this.showMembers = false;
    }
  }

  onVisualizationsClicked(): void {
    if (this.canViewVisualizations) {
      this.showVisualizations = true;
      this.showCollections = false;
      this.showFeedbackAdmin = false;
      this.showMailbox = false;
      this.showInferences = false;
      this.showClusters = false;
      this.showMembers = false;
    }
  }

  onInferencesClicked(): void {
    if (this.canViewInferences) {
      this.showInferences = true;
      this.showClusters = false;
      this.showCollections = false;
      this.showFeedbackAdmin = false;
      this.showMailbox = false;
      this.showVisualizations = false;
      this.showMembers = false;
    }
  }

  onClustersClicked(): void {
    if (this.canViewInferences) {
      this.showClusters = true;
      this.showInferences = false;
      this.showCollections = false;
      this.showFeedbackAdmin = false;
      this.showMailbox = false;
      this.showVisualizations = false;
      this.showMembers = false;
    }
  }

  onMembersClicked(): void {
    if (this.canViewMembers) {
      this.showMembers = true;
      this.showClusters = false;
      this.showInferences = false;
      this.showCollections = false;
      this.showFeedbackAdmin = false;
      this.showMailbox = false;
      this.showVisualizations = false;
    }
  }

  onPromptsClicked(): void {
    if (this.chatAreaComponent) {
      this.chatAreaComponent.openPromptsGalleryModal();
    }
  }

  onBackToChat(): void {
    this.showCollections = false;
    this.showFeedbackAdmin = false;
    this.showMailbox = false;
    this.showVisualizations = false;
    this.showInferences = false;
    this.showClusters = false;
    this.showMembers = false;
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (window.innerWidth <= 768 && this.isSidebarCollapsed) {
      this.isSidebarCollapsed = false;
    }
  }

  onNewChatClicked(): void {
    if (this.chatAreaComponent) {
      this.chatAreaComponent.startNewChat();
    }
    this.showCollections = false;
    this.showFeedbackAdmin = false;
    this.showVisualizations = false;
    this.showMailbox = false;
    this.showInferences = false;
    this.showClusters = false;
    this.showMembers = false;
  }


  onChatSaved(chatData: { chatId: string; label: string }): void {
    // Pass the chat data to sidebar
    if (this.sidebarComponent) {
      this.sidebarComponent.addSavedChat(chatData.chatId, chatData.label);
    }
  }

  onChatHistoryItemClicked(data: { messages: ChatHistoryMessage[]; chatId: string; chatLabel?: string; isLoading?: boolean }): void {
    // Hide Collections view first if it's showing
    if (this.showCollections) {
      this.showCollections = false;  
    }
    if (this.showFeedbackAdmin) {
      this.showFeedbackAdmin = false;
    }
    if (this.showVisualizations) {
      this.showVisualizations = false;
    }
    if (this.showInferences) {
      this.showInferences = false;
    }
    if (this.showClusters) {
      this.showClusters = false;
    }
    if (this.showMailbox) {
      this.showMailbox = false;
    }
    if (this.showMembers) {
      this.showMembers = false;
    }
    
    
    // Only load chat if there are messages (empty messages means just hide Collections)
    if (this.chatAreaComponent && data.messages.length > 0) {
      this.chatAreaComponent.loadChatFromHistory(data.messages, data.chatId, data.isLoading, data.chatLabel);
    } else if (this.chatAreaComponent && data.isLoading) {
      // Handle loading state even with empty messages
      this.chatAreaComponent.loadChatFromHistory(data.messages, data.chatId, data.isLoading, data.chatLabel);
    }
  }

  onChatDeleted(chatId: string): void {
    if (this.chatAreaComponent) {
      this.chatAreaComponent.startNewChat();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
